import { NextPage } from "next";
import Head from "next/head";

import React from "react";

import NavBar from "@/components/layout/NavBar";

const InterviewerApplyPage: NextPage = () => (
  <>
    <Head>
      <title>Interviewers | Apply</title>
    </Head>

    <div className="flex flex-col h-screen overflow-hidden">
      <NavBar />

      <iframe
        className="flex-1"
        src="https://forms.office.com/pages/responsepage.aspx?id=fR87HoVN7Uewb76nNIyUiWwJskl7qalOsAICuoFoNHFURUVPT01WNU9ITVpSSEhONEE3TDRCRDJTNy4u"
        width={"100%"}
      ></iframe>
    </div>
  </>
);

export default InterviewerApplyPage;
